import React from "react";
import { UI } from "@/content/site";

const MEDIA = [
  { name: "CBS", short: "CBS News" },
  { name: "FOX", short: "FOX" },
  { name: "ABC", short: "ABC News" },
  { name: "Dr. Phil", short: "Dr. Phil" },
  { name: "Telemundo", short: "Telemundo" },
];

export default function MediaStrip({ lang }) {
  const ui = UI[lang];
  return (
    <section className="gw-media">
      <div className="gw-container">
        <p className="gw-media-label">{ui.asSeenOn}</p>
        <div className="gw-media-logos">
          {MEDIA.map((m) => (
            <div key={m.name} className="gw-media-item" title={m.short}>
              <span className="gw-media-name">{m.name}</span>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .gw-media { padding: var(--gw-space-10) 0; background: #F5EFE3; }
        .gw-media-label {
          text-align: center;
          font-family: var(--gw-font-sans);
          font-weight: 700;
          letter-spacing: 0.18em;
          font-size: 0.82rem;
          text-transform: uppercase;
          color: var(--gw-muted);
          margin-bottom: var(--gw-space-6);
        }
        .gw-media-logos {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          gap: var(--gw-space-10);
        }
        .gw-media-item {
          font-family: var(--gw-font-serif);
          font-weight: 700;
          font-size: 1.4rem;
          color: var(--gw-text-soft);
          letter-spacing: 0.02em;
          padding: 0 var(--gw-space-4);
          filter: grayscale(1);
          opacity: 0.7;
          transition: opacity 0.2s ease, filter 0.2s ease;
        }
        .gw-media-item:hover { opacity: 1; filter: grayscale(0); color: var(--gw-primary); }
      `}</style>
    </section>
  );
}
